/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildExcelResultDto } from '../../models/child-excel-result-dto';

export interface ExcelControllerChildExcelUpload$Params {
      body: {
'file'?: Blob;
}
}

export function excelControllerChildExcelUpload(http: HttpClient, rootUrl: string, params: ExcelControllerChildExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildExcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, excelControllerChildExcelUpload.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildExcelResultDto>;
    })
  );
}

excelControllerChildExcelUpload.PATH = '/api/excel/child';
